import React from 'react';
import { componentService } from 'js/services/component.service';

export const IdenttManual = React.lazy(() => import(/* webpackChunkName: "identt-manual" */ './IdenttManual'));

componentService.registerPageComponents({ 'identt-manual': IdenttManual });
